import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'
import i18n from "@/helpers/i18n";

export interface Event {
  begin: number,
  code: string
}

export interface State {
  stands:null,
  allShow:any,
  exponents:any,
  show: any | null,
  events: any[] | null,
  loadStatus: boolean,
  eventByCode: any | null,
  loadStatusEventByCode: boolean,
  loadStatusOptions: boolean
}
export interface IExponent {
  allCount:number,
  models:any[]
}

const defaultState: State = {
  stands:null,
  allShow:null,
  exponents:null,
  show: null,
  events: null,
  loadStatus: false,
  eventByCode: null,
  loadStatusEventByCode: false,
  loadStatusOptions: false
};

const getters = {
  exponents: (state: State) => {
    if(state.exponents) {
      return state.exponents.models
    }else { return []}
  },
  allShow: (state: State) => state.allShow,
  show: (state: State) => state.show,
  stands: (state: State) => state.stands,
  events: (state: State) => state.events,
  eventByCode: (state: State) => state.eventByCode,
  loadStatus: (state: State) => state.loadStatus,
  loadStatusOptions: (state: State) => state.loadStatusOptions,
  loadStatusEventByCode: (state: State) => state.loadStatusEventByCode
}

const mutations: MutationTree<State> = {
  changeStatusShow(state: State, payload: any) {
    if (state.eventByCode) {
      const arr = state.eventByCode.shows.map((el: any) => {
        if (el.code === payload.code) {
          return payload
        }
        return el
      })
      state.eventByCode.shows = arr
    }
  },
  addExhibitionByEvent(state: State, payload: any) {
    if (state.eventByCode) {
      state.eventByCode.shows.push(payload)
    }
  },
  editEventByCode(state: State, payload: any) {
    if (state.events) {
      const arr = state.events.map((el) => {
        if (el.code === payload.code) {
          return payload
        }
        return el
      })
      state.events = arr
    }
    if (state.eventByCode) {
      state.eventByCode = payload
    }

  },
  editShowByCode(state: State, payload: any) {
    if (state.eventByCode) {
      const arr = state.eventByCode.shows.map((el:any) => {
        if (el.code === payload.code) {
          return payload
        }
        return el
      })
      state.eventByCode.shows = arr
    }
    if (state.allShow) {
      const arr = state.allShow.map((el:any) => {
        if (el.code === payload.code) {
          el.title = payload.title
          el.begin = payload.begin
          el.end=payload.end
          el.color = payload.color
          el.mapLink = payload.mapLink
          return  el
        }
        return el
      })
      state.allShow = arr
    }
    if (state.show) {
      state.show.title = payload.title
      state.show.begin = payload.begin
      state.show.end = payload.end
      state.show.color = payload.color
      state.show.mapLink = payload.mapLink
    }
  },
  changeOptions(state:State, payload:any){
    if(state.show){
      state.show = payload
    }
  },
  setEventByCode(state: State, payload: [any]) {
    state.eventByCode = payload
  },
  setEvents(state: State, payload: any[]) {
    state.events = payload
  },
  setShow(state: State, payload: any) {
    state.show = payload
  },
  setStands(state: State, payload: any) {
    state.stands = payload
  },
  setAllShow(state: State, payload: any) {
    state.allShow = payload
  },
  setExponents(state: State, payload: any) {
    state.exponents = payload
  },
  setEvent(state: State, payload: any) {
    if (state.events) state.events.push(payload)
  },
  setLoadStatus(state: State, payload: boolean) {
    state.loadStatus = payload
  },
  setLoadStatusOptions(state: State, payload: boolean) {
    state.loadStatusOptions = payload
  },
  setLoadStatusEventByCode(state: State, payload: boolean) {
    state.loadStatusEventByCode = payload
  }
}

const actions: ActionTree<State, RootState> = {
  async loadStandsFromServer({commit, state},payload:string) {
    // commit('setLoadStatus', true)
    try {
      const {data} = await Vue.axios.get('/v4/show/'+payload+'/stands')

      commit('setStands', data.models)
      // this.commit('alerts/setAlert', {
      //   show: true,
      //   messages: ['Стенды загружены']
      // })
    } catch (e) {
      this.commit('alerts/setAlert',{
        show:true,
        color:'red',
        messages:[e.message]
      })
    }
    // commit('setLoadStatus', false)

  },
  async loadAllShowFromServer({commit, state}) {
    commit('setLoadStatus', true)
    try {
      const {data} = await Vue.axios.get('/v4/shows?expand=eventCode,eventTitle,isCurrent')

      commit('setAllShow', data)
      // this.commit('alerts/setAlert', {
      //   show: true,
      //   color: 'green',
      //   messages: ['Выставки загружены']
      // })
    } catch (e) {
      this.commit('alerts/setAlert',{
        show:true,
        color:'red',
        messages:[e.message]
      })
    }
    commit('setLoadStatus', false)

  },
  async loadExponentsFromServer({commit, state},params:string) {
    // commit('setLoadStatus', true)
    try {
      const {data} = await Vue.axios.get('/v4/show/'+params+'/exhibitors?expand=tariff,sentToAmo')

      commit('setExponents', data)
      // this.commit('alerts/setAlert', {
      //   show: true,
      //   color: 'green',
      //   messages: ['Участники загружены']
      // })
    } catch (e) {
      this.commit('alerts/setAlert',{
        show:true,
        color:'red',
        messages:[e.message]
      })
    }
    // commit('setLoadStatus', false)

  },
  async loadShowFromServer({commit, state},params:string) {
    commit('setLoadStatus', true)
    try {
      const {data} = await Vue.axios.get('/v4/show/'+params+'?expand=options,location,eventCode,companiesCount,eventTitle,standsCount,badgesCount,visitorBadgesCount,standmanBadgesCount,freeCompaniesCount,proCompaniesCount,productsCount,businessCompaniesCount,scansStatistic,sentToAmo,umap')
      commit('setShow', data)
      commit('setLoadStatus', false)
      commit('setLoadStatusOptions', false)
    } catch (e) {
      this.commit('alerts/setAlert',{
        show:true,
        color:'red',
        messages:[e.message]
      })
      commit('setLoadStatus', false)
      commit('setLoadStatusOptions', false)
    }


  },
  async loadEventsFromServer({commit, state}) {

    commit('setLoadStatus', true)
    try {
      const {data} = await Vue.axios.get('/v4/events?expand=isCurrent')
      let data_events = data.map((elem: any[]) => {
        return {...elem, show: null}
      })
      commit('setEvents', data_events)
      // this.commit('alerts/setAlert', {
      //   show: true,
      //   color: 'green',
      //   messages: ['События загружены']
      // })
    } catch (e) {
      console.log(e.message)
      this.commit('alerts/setAlert',{
        show:true,
        color:'red',
        messages:[e.message]
      })
    }
    commit('setLoadStatus', false)

  },
  async loadEventByCodeFromServer({commit, state}, payload: string) {
    commit('setLoadStatusEventByCode', true)
    try {
      const {data} = await Vue.axios.get('/v4/event/' + payload)
      commit('setEventByCode', data)
      // this.commit('alerts/setAlert', {
      //   show: true,
      //   color: 'green',
      //   messages: ['Событие загружено']
      // })
    } catch (e) {
      this.commit('alerts/setAlert',{
        show:true,
        color:'red',
        messages:[e.message]
      })
      console.log(e.message)
    }
    commit('setLoadStatusEventByCode', false)


  },
  async saveEventFromServer({commit, state}, payload: any) {
    commit('setLoadStatus', true)
    let params = {
      "title": payload.title,
      "_organizer": payload._organizer,
      "location": {
        "_country": payload.location._country,
        "city": payload.location.city
      }
    }
    try {
      const {data} = await Vue.axios.post('/v4/event', params)
      commit('setEvent', data)
      this.commit('dialog/SetFullDialogShow', false)

      this.commit('alerts/setAlert', {
        show: true,
        messages: [i18n.t('events.notifications.event_created')]
      })
      return data
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e.message]
      })
      return false
    }
    commit('setLoadStatus', false)

  },
  async editShowFromServer({commit, state}, payload: any) {
    const params = {...payload}
    delete params.code

    commit('setLoadStatus', true)

    try {
      const {data} = await Vue.axios.patch('/v4/show/' + payload.code, params)
        console.log(data.status )
        if(data.status !== 'err'){
            commit('editShowByCode', data)
            this.commit('dialog/SetFullDialogShow', false)
            this.commit('alerts/setAlert', {
                show: true,
                messages: [i18n.t('events.notifications.exhibition_edit')]
            })
        }else {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: data.errors[0].messages
            })
        }

    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e.message]
      })
    }
    commit('setLoadStatus', false)

  },
  async editEventFromServer({commit, state}, payload: any) {
    const params = {...payload}
    delete params.code

    commit('setLoadStatus', true)

    try {
      const {data} = await Vue.axios.patch('/v4/event/' + payload.code, params)
      commit('editEventByCode', data)
      this.commit('dialog/SetFullDialogShow', false)
      this.commit('alerts/setAlert', {
        show: true,
        messages: [i18n.t('events.notifications.event_edit')]
      })
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e.message]
      })
    }
    commit('setLoadStatus', false)

  },
  async saveExhibitionFromServer({commit, state}, payload: any) {
    const params = {...payload}
    delete params.code
    commit('setLoadStatus', true)

    try {
      const {data} = await Vue.axios.post('/v4/event/' + payload.code + '/show', params)
      commit('addExhibitionByEvent', data)
      this.commit('dialog/SetFullDialogShow', false)
      this.commit('alerts/setAlert', {
        show: true,
        messages: [i18n.t('events.notifications.exhibition_created')]
      })
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e.message]
      })
    }
    commit('setLoadStatus', false)

  },
  async changeStatusShow({commit, state}, payload: any) {
    const status = payload.status === 'active' ? 'deactivate' : 'activate'

    commit('setLoadStatus', true)

    try {
      const {data} = await Vue.axios.patch('/v4/show/' + payload.code + '/' + status)
      commit('changeStatusShow', data)
      this.commit('alerts/setAlert', {
        show: true,
        messages: [i18n.t('events.notification.status_changed')]
      })
      return true
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e.message]
      })
    }
    commit('setLoadStatus', false)

  },
  async changeOptionsShowFromServer({commit, state}, payload: any) {
    const params = {...payload}
    delete params.code
    try {
      commit('setLoadStatusOptions', true)
      const {data} = await Vue.axios.patch('/v4/show/' + payload.code, params)
     this.dispatch('events/loadShowFromServer', payload.code)

    } catch (e) {
      commit('setLoadStatusOptions', false)
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e.message]
      })
    }
    commit('setLoadStatus', false)
  },

}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
